<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Email Services">
    <div class="email-services">
      <div class="search">
        <app-search-field
          placeholder="Search website or mailbox"
          (searchText)="onSearch($event)"
        ></app-search-field>
      </div>

      <div class="header row">
        <h2>Recently added Email Services</h2>
        <button matButton="filled" class="app-btn-small" (click)="addMailbox()">
          <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
          Add Mail Service
        </button>
      </div>

      <mat-card appearance="outlined" class="table-container">
        @if (mailboxes$ | async; as mailboxes) {
          <app-table
            #table
            [columns]="mailboxesColumns"
            [dataSource]="mailboxes"
            [totalCount]="totalServices()"
            (pageChange)="handlePageEvent($event)"
            [expandableRows]="true"
          >
            <ng-container matColumnDef="mailService">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Mail Service</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle
                  [checked]="element.status !== 5"
                  (change)="onServiceToggleChange($event, element.id)"
                  [disabled]="mailboxIdToggle() === element.id"
                ></mat-slide-toggle>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                <app-status-label [status]="toStatus(element.status)"></app-status-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="button"
                    matTooltip="List Mailboxes"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="showMailboxUsers(element)"
                  >
                    <fa-icon [icon]="['fas', 'list-ul']" size="lg"></fa-icon>
                    <span class="users-count">{{ element.users.length }}</span>
                  </button>

                  <button
                    matRipple
                    class="button"
                    matTooltip="Add Mailbox"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="addMailboxUser(element)"
                  >
                    <img
                      class="custom-icon"
                      src="assets/icons/custom-mail-plus-purple.svg"
                      alt="Mail-plus"
                    />
                  </button>
                  <button
                    matRipple
                    class="button"
                    matTooltip="Delete All Mailboxes"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="deleteMailbox(element)"
                  >
                    <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-template #expandedRow let-row>
              @if (row.users.length) {
                @if (expandedMailbox$ | async; as mailbox) {
                  <div class="expanded-row column">
                    <h2>Mailboxes</h2>
                    <div class="inner-table-container">
                      <app-table
                        [columns]="mailboxUsersColumns"
                        [dataSource]="mailbox.users"
                        [totalCount]="mailbox.users.length || 0"
                        (pageChange)="handlePageEvent($event)"
                        [showPaginator]="false"
                      >
                        <ng-container matColumnDef="mailbox">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mailbox</th>
                          <td mat-cell *matCellDef="let element">
                            <mat-slide-toggle
                              [checked]="element.status !== 'DISABLED'"
                              (change)="onUserToggleChange($event, element.id)"
                              [disabled]="mailboxUserIdToggle() === element.id"
                            ></mat-slide-toggle>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                          <td mat-cell *matCellDef="let element">
                            <app-status-label
                              [status]="fromUserStatus(element.status)"
                            ></app-status-label>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="buttons">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                          <td mat-cell *matCellDef="let element">
                            <div class="buttons">
                              <button
                                matRipple
                                class="button"
                                matTooltip="Login to Webmail"
                                [matTooltipShowDelay]="500"
                                matTooltipPosition="above"
                              >
                                <fa-icon
                                  [icon]="['fas', 'arrow-right-to-bracket']"
                                  size="lg"
                                ></fa-icon>
                              </button>

                              <button
                                matRipple
                                class="button"
                                matTooltip="Mailbox Settings"
                                [matTooltipShowDelay]="500"
                                matTooltipPosition="above"
                                (click)="editMailboxUser(element, row.website.domain)"
                              >
                                <fa-icon [icon]="['fas', 'gear']" size="lg"></fa-icon>
                              </button>
                              <button
                                matRipple
                                class="button"
                                matTooltip="Delete Mailbox"
                                [matTooltipShowDelay]="500"
                                matTooltipPosition="above"
                                (click)="deleteMailboxUser(element)"
                              >
                                <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                              </button>
                            </div>
                          </td> </ng-container
                      ></app-table>
                    </div>
                  </div>
                }
              }
            </ng-template>
          </app-table>
        }
      </mat-card>
    </div>
  </mat-tab>
  <mat-tab label="Mailboxes">
    <div class="email-services">
      <div class="search">
        <app-search-field
          placeholder="Search website or mailbox"
          (searchText)="onUsersSearch($event)"
        ></app-search-field>
      </div>

      <div class="header row">
        <h2>Mailboxes</h2>
        <button matButton="filled" class="app-btn-small" (click)="addNewMailboxUser()">
          <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
          Add Mailbox
        </button>
      </div>

      <mat-card appearance="outlined" class="table-container">
        @if (mailboxUsers$ | async; as users) {
          <app-table
            #table
            [columns]="mailboxUsersColumns"
            [dataSource]="users"
            [totalCount]="totalUsers()"
            (pageChange)="handleUsersPageEvent($event)"
          >
            <ng-container matColumnDef="mailbox">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Mailbox</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle
                  [checked]="element.status !== 'DISABLED'"
                  (change)="onUserToggleChange($event, element.id)"
                  [disabled]="mailboxUserIdToggle() === element.id"
                ></mat-slide-toggle>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                <app-status-label [status]="fromUserStatus(element.status)"></app-status-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="button"
                    matTooltip="Login to Webmail"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                  >
                    <fa-icon [icon]="['fas', 'arrow-right-to-bracket']" size="lg"></fa-icon>
                  </button>

                  <button
                    matRipple
                    class="button"
                    matTooltip="Mailbox Settings"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="editMailboxUser(element, 'Unknown')"
                  >
                    <fa-icon [icon]="['fas', 'gear']" size="lg"></fa-icon>
                  </button>
                  <button
                    matRipple
                    class="button"
                    matTooltip="Delete Mailbox"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="deleteMailboxUser(element)"
                  >
                    <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>
          </app-table>
        }
      </mat-card>
    </div>
  </mat-tab>
</mat-tab-group>
